import React from "react"
import { Cursor } from "../../elements"
import styled from "styled-components"

const ContactCursor = ({ xValue, yValue }) => {
  return (
    <Contact
      top={yValue}
      left={xValue}
      height="150"
      width="150"
      zIndex="999999"
    >
      <svg
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 145 145"
      >
        <path
          className="st10"
          d="M76.1,17.2L84,28.7c1.1,1.6,3.2,2.3,5,1.6l13.1-4.7c2.9-1,5.9,1.2,5.8,4.2l-0.4,13.9c-0.1,2,1.2,3.7,3.1,4.3
	L124,52c2.9,0.9,4.1,4.4,2.2,6.8l-8.5,11c-1.2,1.6-1.2,3.7,0,5.3l8.5,11c1.9,2.4,0.7,6-2.2,6.8l-13.4,3.9c-1.9,0.6-3.2,2.3-3.1,4.3
	l0.4,13.9c0.1,3.1-2.9,5.2-5.8,4.2L89,114.7c-1.9-0.7-3.9,0-5,1.6l-7.9,11.5c-1.7,2.5-5.4,2.5-7.2,0L61,116.3
	c-1.1-1.6-3.2-2.3-5-1.6l-13.1,4.7c-2.9,1-5.9-1.2-5.8-4.2l0.4-13.9c0.1-2-1.2-3.7-3.1-4.3L21,93c-2.9-0.9-4.1-4.4-2.2-6.8l8.5-11
	c1.2-1.6,1.2-3.7,0-5.3l-8.5-11c-1.9-2.4-0.7-6,2.2-6.8l13.4-3.9c1.9-0.6,3.2-2.3,3.1-4.3l-0.4-13.9c-0.1-3.1,2.9-5.2,5.8-4.2
	L56,30.3c1.9,0.7,3.9,0,5-1.6l7.9-11.5C70.6,14.7,74.4,14.7,76.1,17.2z"
        />
        <g>
          <path
            className="st12"
            d="M54.4,80c-0.1,0-0.2-0.1-0.2-0.2v-4.7l-2.4-7.2c0-0.1,0-0.2,0.1-0.2h2c0.1,0,0.2,0.1,0.2,0.2l1.2,4.5h0.1
		l1.2-4.5c0-0.1,0.1-0.2,0.2-0.2h2c0.1,0,0.2,0.1,0.1,0.2l-2.4,7.2v4.7c0,0.1-0.1,0.2-0.2,0.2H54.4z"
          />
          <path
            className="st12"
            d="M61.4,67.9c0-0.1,0.1-0.2,0.2-0.2h5.3c0.1,0,0.2,0.1,0.2,0.2v1.8c0,0.1-0.1,0.2-0.2,0.2h-3.1
		c-0.1,0-0.1,0-0.1,0.1v2.7c0,0.1,0,0.1,0.1,0.1h2.6c0.1,0,0.2,0.1,0.2,0.2v1.8c0,0.1-0.1,0.2-0.2,0.2h-2.6c-0.1,0-0.1,0-0.1,0.1
		v2.8c0,0.1,0,0.1,0.1,0.1h3.1c0.1,0,0.2,0.1,0.2,0.2v1.8c0,0.1-0.1,0.2-0.2,0.2h-5.3c-0.1,0-0.2-0.1-0.2-0.2V67.9z"
          />
          <path
            className="st12"
            d="M72.8,80.1c-2.2,0-3.3-1.2-3.3-3.3c0-0.1,0-0.2,0.1-0.2l1.9-0.3c0.1,0,0.2,0,0.2,0.1c0,1.1,0.4,1.6,1.1,1.6
		c0.7,0,1-0.3,1-1.5c0-1.1-0.2-1.5-1.1-1.8l-0.7-0.3c-1.7-0.7-2.3-1.6-2.3-3.5c0-2.2,1.1-3.4,3.2-3.4c2.1,0,3.2,1.1,3.2,3
		c0,0.1-0.1,0.2-0.2,0.2L74,71.1c-0.1,0-0.2,0-0.2-0.1c0-0.9-0.3-1.3-1-1.3c-0.6,0-0.9,0.4-0.9,1.2c0,0.9,0.2,1.2,1.2,1.6l0.7,0.3
		c1.7,0.6,2.3,1.5,2.3,3.6C76.2,78.8,75.2,80.1,72.8,80.1z"
          />
          <path
            className="st12"
            d="M81.8,80.1c-2.2,0-3.3-1.2-3.3-3.3c0-0.1,0-0.2,0.1-0.2l1.9-0.3c0.1,0,0.2,0,0.2,0.1c0,1.1,0.4,1.6,1.1,1.6
		c0.7,0,1-0.3,1-1.5c0-1.1-0.2-1.5-1.1-1.8l-0.7-0.3c-1.7-0.7-2.3-1.6-2.3-3.5c0-2.2,1.1-3.4,3.2-3.4c2.1,0,3.2,1.1,3.2,3
		c0,0.1-0.1,0.2-0.2,0.2l-1.8,0.3c-0.1,0-0.2,0-0.2-0.1c0-0.9-0.3-1.3-1-1.3c-0.6,0-0.9,0.4-0.9,1.2c0,0.9,0.2,1.2,1.2,1.6l0.7,0.3
		c1.7,0.6,2.3,1.5,2.3,3.6C85.2,78.8,84.3,80.1,81.8,80.1z"
          />
          <path
            className="st12"
            d="M90.9,80.1c-2.2,0-3.3-1.2-3.3-3.3c0-0.1,0-0.2,0.1-0.2l1.9-0.3c0.1,0,0.2,0,0.2,0.1c0,1.1,0.4,1.6,1.1,1.6
		c0.7,0,1-0.3,1-1.5c0-1.1-0.2-1.5-1.1-1.8L90,74.5c-1.7-0.7-2.3-1.6-2.3-3.5c0-2.2,1.1-3.4,3.2-3.4c2.1,0,3.2,1.1,3.2,3
		c0,0.1-0.1,0.2-0.2,0.2l-1.8,0.3c-0.1,0-0.2,0-0.2-0.1c0-0.9-0.3-1.3-1-1.3c-0.6,0-0.9,0.4-0.9,1.2c0,0.9,0.2,1.2,1.2,1.6l0.7,0.3
		c1.7,0.6,2.3,1.5,2.3,3.6C94.3,78.8,93.3,80.1,90.9,80.1z"
          />
        </g>
        <g>
          <path
            className="st10"
            id="line_1"
            d="M112.9,25.3c-0.2,0-0.4,0-0.6-0.1c-0.9-0.3-1.3-1.3-0.9-2.2l4.3-10.6c0.3-0.9,1.3-1.3,2.2-0.9
		c0.9,0.3,1.3,1.3,0.9,2.2l-4.3,10.6C114.2,24.9,113.6,25.3,112.9,25.3z"
          />
        </g>
        <g>
          <path
            className="st10"
            id="line_2"
            d="M118.1,28.7c-0.4,0-0.7-0.1-1-0.3c-0.7-0.6-0.9-1.6-0.3-2.3l10.9-14.4c0.6-0.7,1.6-0.9,2.3-0.3
		s0.9,1.6,0.3,2.3l-10.9,14.4C119.1,28.5,118.6,28.7,118.1,28.7z"
          />
        </g>
        <g>
          <path
            className="st10"
            id="line_3"
            d="M122.8,33.7c-0.6,0-1.2-0.3-1.5-0.9c-0.4-0.8,0-1.8,0.8-2.2l9.4-4.5c0.8-0.4,1.8,0,2.2,0.8
		c0.4,0.8,0,1.8-0.8,2.2l-9.4,4.5C123.3,33.6,123.1,33.7,122.8,33.7z"
          />
        </g>
        <g>
          <path
            className="st5"
            d="M52.4,77c-0.1,0-0.2-0.1-0.2-0.2v-4.7l-2.4-7.2c0-0.1,0-0.2,0.1-0.2h2c0.1,0,0.2,0.1,0.2,0.2l1.2,4.5h0.1
		l1.2-4.5c0-0.1,0.1-0.2,0.2-0.2h2c0.1,0,0.2,0.1,0.1,0.2l-2.4,7.2v4.7c0,0.1-0.1,0.2-0.2,0.2H52.4z"
          />
          <path
            className="st5"
            d="M59.4,64.9c0-0.1,0.1-0.2,0.2-0.2h5.3c0.1,0,0.2,0.1,0.2,0.2v1.8c0,0.1-0.1,0.2-0.2,0.2h-3.1
		c-0.1,0-0.1,0-0.1,0.1v2.7c0,0.1,0,0.1,0.1,0.1h2.6c0.1,0,0.2,0.1,0.2,0.2v1.8c0,0.1-0.1,0.2-0.2,0.2h-2.6c-0.1,0-0.1,0-0.1,0.1
		v2.8c0,0.1,0,0.1,0.1,0.1h3.1c0.1,0,0.2,0.1,0.2,0.2v1.8c0,0.1-0.1,0.2-0.2,0.2h-5.3c-0.1,0-0.2-0.1-0.2-0.2V64.9z"
          />
          <path
            className="st5"
            d="M70.8,77.1c-2.2,0-3.3-1.2-3.3-3.3c0-0.1,0-0.2,0.1-0.2l1.9-0.3c0.1,0,0.2,0,0.2,0.1c0,1.1,0.4,1.6,1.1,1.6
		c0.7,0,1-0.3,1-1.5c0-1.1-0.2-1.5-1.1-1.8l-0.7-0.3c-1.7-0.7-2.3-1.6-2.3-3.5c0-2.2,1.1-3.4,3.2-3.4c2.1,0,3.2,1.1,3.2,3
		c0,0.1-0.1,0.2-0.2,0.2L72,68.1c-0.1,0-0.2,0-0.2-0.1c0-0.9-0.3-1.3-1-1.3c-0.6,0-0.9,0.4-0.9,1.2c0,0.9,0.2,1.2,1.2,1.6l0.7,0.3
		c1.7,0.6,2.3,1.5,2.3,3.6C74.2,75.8,73.2,77.1,70.8,77.1z"
          />
          <path
            className="st5"
            d="M79.8,77.1c-2.2,0-3.3-1.2-3.3-3.3c0-0.1,0-0.2,0.1-0.2l1.9-0.3c0.1,0,0.2,0,0.2,0.1c0,1.1,0.4,1.6,1.1,1.6
		c0.7,0,1-0.3,1-1.5c0-1.1-0.2-1.5-1.1-1.8l-0.7-0.3c-1.7-0.7-2.3-1.6-2.3-3.5c0-2.2,1.1-3.4,3.2-3.4c2.1,0,3.2,1.1,3.2,3
		c0,0.1-0.1,0.2-0.2,0.2l-1.8,0.3c-0.1,0-0.2,0-0.2-0.1c0-0.9-0.3-1.3-1-1.3c-0.6,0-0.9,0.4-0.9,1.2c0,0.9,0.2,1.2,1.2,1.6l0.7,0.3
		c1.7,0.6,2.3,1.5,2.3,3.6C83.2,75.8,82.3,77.1,79.8,77.1z"
          />
          <path
            className="st5"
            d="M88.9,77.1c-2.2,0-3.3-1.2-3.3-3.3c0-0.1,0-0.2,0.1-0.2l1.9-0.3c0.1,0,0.2,0,0.2,0.1c0,1.1,0.4,1.6,1.1,1.6
		c0.7,0,1-0.3,1-1.5c0-1.1-0.2-1.5-1.1-1.8L88,71.5c-1.7-0.7-2.3-1.6-2.3-3.5c0-2.2,1.1-3.4,3.2-3.4c2.1,0,3.2,1.1,3.2,3
		c0,0.1-0.1,0.2-0.2,0.2l-1.8,0.3c-0.1,0-0.2,0-0.2-0.1c0-0.9-0.3-1.3-1-1.3c-0.6,0-0.9,0.4-0.9,1.2c0,0.9,0.2,1.2,1.2,1.6l0.7,0.3
		c1.7,0.6,2.3,1.5,2.3,3.6C92.3,75.8,91.3,77.1,88.9,77.1z"
          />
        </g>
      </svg>
    </Contact>
  )
}

export default ContactCursor

const Contact = styled(Cursor)`
  .st0 {
    fill: #eed36c;
  }
  .st1 {
    fill: #83c8b6;
  }
  .st2 {
    fill: #e14263;
  }
  .st3 {
    fill: none;
    stroke: #0e363d;
    stroke-width: 1.5538;
    stroke-miterlimit: 10;
  }
  .st4 {
    fill: none;
    stroke: #0e363d;
    stroke-width: 0.5614;
    stroke-miterlimit: 10;
  }
  .st5 {
    fill: #ffffff;
  }
  .st6 {
    fill: #c5934c;
  }
  .st7 {
    fill: none;
    stroke: #0e363d;
    stroke-width: 1.5091;
    stroke-miterlimit: 10;
  }
  .st8 {
    fill: #0000ff;
  }
  .st9 {
    fill: none;
    stroke: #0e363d;
    stroke-width: 0.5797;
    stroke-miterlimit: 10;
  }
  .st10 {
    fill: #e22651;
  }
  .st11 {
    fill: none;
    stroke: #0e363d;
    stroke-width: 0.75;
    stroke-miterlimit: 10;
  }
  .st12 {
    fill: none;
    stroke: #db6780;
    stroke-width: 0.75;
    stroke-miterlimit: 10;
  }
  .st13 {
    fill: #e5a13d;
  }
  .st14 {
    fill: #0d2e33;
  }
  .st15 {
    fill: #b2c4aa;
  }
  .st16 {
    fill: none;
    stroke: #e92e55;
    stroke-width: 0.75;
    stroke-miterlimit: 10;
  }
  .st17 {
    fill: none;
    stroke: #e4af53;
    stroke-width: 4;
    stroke-miterlimit: 10;
  }
  .st18 {
    fill: none;
    stroke: #10363c;
    stroke-width: 4;
    stroke-miterlimit: 10;
  }
  .st19 {
    fill: none;
    stroke: #c4d1bf;
    stroke-width: 4;
    stroke-miterlimit: 10;
  }

  #line_1,
  #line_2,
  #line_3 {
    opacity: 0;
    animation: appear 0.3s infinite;
  }

  #line_1 {
    animation-delay: 0;
  }

  #line_2 {
    animation-delay: 0.05s;
  }
  #line_3 {
    animation-delay: 0.1s;
  }

  @keyframes appear {
    0% {
      opacity: 0;
    }
    70% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }
`
